export enum QueryParams {
    DEVICE_CONTEXT = 'deviceContext',
    REDIRECT_TO = 'redirect-to'
  }
  
  